<template>
  <ul :class="$style.ogpList">
    <li v-for="(ogp, index) in ogpItems" :key="index">
      <vc-share-ogp
        v-if="ogp && ogp.isSuccess"
        :url="ogp.url"
        :image-url="ogp.imageUrl"
        :title="ogp.title"
        :description="ogp.description"
        :host="ogp.host"
      ></vc-share-ogp>
    </li>
  </ul>
</template>

<script>
export default {
  name: "vc-share-ogp-list",
  props: {
    id: {
      type: String,
      default: "_default"
    },
    content: {
      type: String,
      default: ""
    },
    ogps: {
      type: Array,
      default: () => []
    },
    getOgpFromContent: {
      type: Function,
      default: () => {}
    }
  },
  mounted() {
    this.getOgpFromContent({
      id: this.id,
      content: this.content
    });
  },
  computed: {
    ogpItems() {
      const ogpItem = this.ogps.find(o => o.id == this.id);
      return ogpItem ? ogpItem.ogps : [];
    }
  }
};
</script>

<style module>
.ogpList {
  padding: 0;
}

.ogpList > li {
  list-style: none;
}
</style>
